// ContactModal.js
import { useEffect, useState } from "react";
import stylez from "./ContactModal.module.css";
import { useNavigate } from 'react-router-dom'
import Modal from "../../Shared/Modal/Modal";
import axiosInstance from "../../../Configuration/axiosInstance";

const ContactsModal = ({ show, setShow, id }) => {
  const [customer, setCustomer] = useState();
  
  const navigate = useNavigate();
  

  const updateCustomer = (customer) => {
    navigate('/customers/updateCustomer', { state: customer });
  };

  useEffect(() => {
    axiosInstance.get(`customers/${id}`).then((res) => {
      setCustomer(res.data.data);
    });
  }, []);

  return (
    <Modal show={show} setShow={setShow}>

      <div className={stylez.container}>
        <div className={stylez.content}>
          <div className={stylez.infoContainer}>
            <div className={stylez.label}>Name:</div>
            <div className={stylez.label}>Person in Charge:</div>
            <div className={stylez.label}>ABN:</div>
            <div className={stylez.label}>Address:</div>
            <div className={stylez.label}>Email:</div>
            <div className={stylez.label}>Customer Type:</div>
            <div className={stylez.label}>Phone:</div>
          </div>
          <div className={stylez.dataContainer}>
            <div className={stylez.data}>{customer?.businessName}</div>
            <div className={stylez.data}>{customer?.pic}</div>
            <div className={stylez.data}>{customer?.abn}</div>
            <div className={stylez.data}>{customer?.address}</div>
            <div className={stylez.data}>{customer?.email}</div>
            <div className={stylez.data}>{customer?.customer_type}</div>
            <div className={stylez.data}>{customer?.phone}</div>
          </div>
        </div> 

        <button
        style={{marginRight:"10px"}}
                      className='editBtn'
                
                      onClick={() => updateCustomer(customer)}
                    >
                      Update
                    </button>
               
        <button
          className={stylez.closeButton}
          onClick={() => setShow(false)}
        >
          Close
        </button>
      </div>
     
     
    </Modal>
  );
};

export default ContactsModal;
